"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Timestamp = (function () {
    function Timestamp(timestamp) {
        if (timestamp === void 0) { timestamp = Date.now(); }
        this.timestamp = timestamp;
    }
    Timestamp.prototype.toJSON = function () {
        return this.timestamp;
    };
    return Timestamp;
}());
exports.Timestamp = Timestamp;
//# sourceMappingURL=Timestamp.js.map